
import { i18nText } from '@/locales';
import {Form} from "@/form/form";
import {Validate} from "@/plugins/Vuelidate/Decorators";
import {numeric, required, requiredIf} from "vuelidate/lib/validators";
import {Component} from "vue-property-decorator";
import {StaffScheduleAddRequestType} from "@/form/staff/schedule/add.types";
import {StaffScheduleUpdateRequestType} from "@/form/staff/schedule/update.types";

@Component
export default class StaffScheduleAddForm extends Form{
    @Validate(required, i18nText("Не выбран сотрудник"))
    staff_id: number | null = null;

    @Validate(required, i18nText("Не выбран месяц"))
    month: number | null = null;
    @Validate(required, i18nText("Не выбран год"))
    year: number | null = null;
    @Validate(required, i18nText("Не выбран день"))
    day: number | null = null;

    working_day: boolean = false;

    // @Validate(required, 'Не выбран день')
    work_start: string | null = null;
    // @Validate(required, 'Не выбран день')
    work_finish: string | null = null;

    break_start: string | null = null;
    break_finish: string | null = null;

    getFormData(): StaffScheduleAddRequestType {
        return {
            staff_id: this.staff_id,
            month: this.month,
            year: this.year,
            day: this.day,
            working_day: this.working_day,
            work_start: this.work_start,
            work_finish: this.work_finish,
            break_start: this.break_start,
            break_finish: this.break_finish
        }
    }
    setFormData(data: StaffScheduleAddRequestType): void {
        this.staff_id = data.staff_id;
        this.month = data.month;
        this.year = data.year;
        this.day = data.day;
        this.working_day = data.working_day;
        this.work_start = data.work_start;
        this.work_finish = data.work_finish;
        this.break_start = data.break_start;
        this.break_finish = data.break_finish;
    }
}
